// @flow

import * as React from 'react';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import MeatballsIcon from 'esm-web-pro/components/layout/sidePanel/icons/MeatballsIcon';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import { injectIntl, IntlShape } from 'react-intl';
import { withRouter } from 'react-router';
import type { RouterHistory, Match } from 'react-router-dom';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';

type Props = {
    point: Object,
    onClick: (point: Object) => void,
    clicked: string,
    intl: IntlShape,
    history: RouterHistory,
    match: Match,
    getName: Function,
}

const Point12Row = (props: Props) => {
    const {
        point, onClick, clicked, intl: { formatMessage }, history, match, getName,
    } = props;

    const actions = [
        {
            key: `point-${point.id}-more`,
            icon: <MeatballsIcon />,
            size: '20px',
            width: '3px',
            callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                const path = match.url.split('/layer');
                history.push(`${path[0]}/layer/${point.type}/${point.identity}`);
            },
            tooltip: formatMessage(actionMessages.more),
        },
    ];

    return (
        <ContentRow
            onClick={() => onClick(point)}
            clickedRowIdentity={clicked}
            rowId={`point-${point.id}`}
            actions={(
                <RowActions actions={actions} />
            )}
            padLevel={1}
        >
            <ValueText>
                {getName(point, formatMessage)}
            </ValueText>
        </ContentRow>
    );
};

export default withRouter(injectIntl(Point12Row));
